<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { _ } from 'svelte-i18n';
	import { obj, css } from '$lib/utils/rgba-convert';
	import InviteModal from '$lib/components/InviteModal/InviteModal.svelte';
	import { page } from '$app/stores';
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;

	let hoverText = '';
	const displayInvite = () => (hoverText = $_('hub.invite.members'));
	const displayGroup = () => (hoverText = $_('hubs.view.group.page'));
	const resetHoverText = () => (hoverText = '');
	const groupPageUrl = `${$page.url.origin}/${$page.params.hubPrefix}/group/collaborators`;
	$: getBackgroundColor = () => {
		const { r, g, b } = obj($hub.theme.coverFontColor);
		return css({ r, g, b, a: 0.2 * 255 });
	};
</script>

{#if $hub.user_context.perms.team.view.collaborators || $hub.user_context.perms.team.view.members || $hub.user_context.perms.team.invites?.collaborator}
	<div
		class="usersCounter"
		style={`background-color: ${getBackgroundColor()};color: ${$hub.theme.coverFontColor}}`}
	>
		{#if $hub.user_context.perms.team.view.collaborators || $hub.user_context.perms.team.view.members}
			<a href={groupPageUrl}>
				<!-- svelte-ignore a11y-no-static-element-interactions -->
				<div class="groupIcon" on:mouseenter={displayGroup} on:mouseleave={resetHoverText}>
					<Icon clickable icon="team" size="20" color={$hub.theme.coverFontColor} />
					<div class="userCount" style={`color: ${$hub.theme.coverFontColor}`}>
						{$hub.user_count}
					</div>
				</div>
			</a>
		{/if}
		<!-- TODO: The invite modals role selector should respect the perms -->
		{#if $hub.user_context.perms.team.invites?.collaborator}
			<div class="invite">
				<!-- svelte-ignore a11y-no-static-element-interactions -->
				<div class="inviteIcon" on:mouseenter={displayInvite} on:mouseleave={resetHoverText}>
					<InviteModal>
						<Icon clickable icon="add" size="20" color={$hub.theme.coverFontColor} />
					</InviteModal>
				</div>
			</div>
		{/if}
	</div>
	{#if hoverText}
		<div class="hoverText">
			<p style={`color: ${$hub.theme.coverFontColor}`}>{hoverText}</p>
		</div>
	{/if}
{/if}

<style>
	a {
		color: inherit;
		text-decoration: none;
	}

	.usersCounter {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-block: 0;
		margin-inline: var(--gutterSmall);
		padding-block: var(--gutterSmall);
		padding-inline: var(--gutterSmaller);
		border-radius: 30px;
	}

	.usersCounter div {
		padding-block: 0;
		padding-inline: var(--gutterSmaller);
	}

	.userCount {
		padding: 0;
		font-size: var(--fontSizeSmaller);
	}

	.groupIcon {
		display: flex;
		align-items: center;
		margin-block: 0;
		margin-inline: var(--gutterSmaller);
	}

	.inviteIcon {
		margin-block: 0;
		margin-inline: -3px;
	}

	.invite {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.invite::before {
		content: '|';
		block-size: 100%;
		padding-inline-end: var(--gutterSmall);
		color: var(--coverFontColor);
	}

	.hoverText {
		display: flex;
		align-items: center;
		white-space: nowrap;
	}

	p {
		position: absolute;
		color: var(--coverFontColor);
		font-size: var(--fontSizeSmaller);
	}
</style>
